import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showBranding?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '',
  showBranding = false
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  if (showBranding) {
    return (
      <div className={`flex flex-col items-center justify-center min-h-screen entry-loading ${className}`}>
        <div className="entry-loading-content text-center" role="status" aria-live="polite">
          {/* Logo */}
          <div className="mb-6">
            <div className="w-20 h-20  flex items-center justify-center mx-auto mb-4">
              <img src="/images/finflow-mark.svg" alt="" width="80" height="80" className="w-20 h-20 object-contain" />
            </div>
            <h1 className="text-2xl entry-loading-title mb-2">FinFlow Finance</h1>
            <p className="entry-loading-muted text-sm">Your money, clearly.</p>
          </div>
          
          {/* Loading Spinner */}
          <div className="flex items-center justify-center">
            <div className={`${sizeClasses[size]} animate-spin rounded-full border-2 entry-loading-ring`}></div>
          </div>
          
          {/* Loading Text */}
          <p className="entry-loading-muted text-sm mt-4">Loading…</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center min-h-screen entry-loading ${className}`}>
      <div className={`${sizeClasses[size]} animate-spin rounded-full border-2 entry-loading-ring`}></div>
    </div>
  );
};

export default LoadingSpinner;
